import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getHPODiseases } from "../../../../state/selectors/HPO.selectors";
import { DEFAULT_COLOR } from "../../../../common/helpers/helpers";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";

const GeneHpoTreeCard = ({ card, diseases }) => {
  const isDisabled = !diseases || !diseases.length;
  const color = diseases
    ? getPathogenicityColorByAllNames("Pathogenic")
    : DEFAULT_COLOR;

  const numberOfDiseases = diseases?.length;

  return (
    <CardWrapper {...card} isDisabled={isDisabled} color={color}>
      {numberOfDiseases && (
        <div>
          {"Number of diseases: "}
          <span className="tw-font-bold" data-testid="hpo-diseases">
            {numberOfDiseases}
          </span>
        </div>
      )}
    </CardWrapper>
  );
};

GeneHpoTreeCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  diseases: PropTypes.arrayOf(PropTypes.shape({})),
};

GeneHpoTreeCard.defaultProps = {
  diseases: null,
};

const mapStateToProps = (state) => ({
  diseases: getHPODiseases(state),
});

export default connect(mapStateToProps, {})(GeneHpoTreeCard);
